import { createFileRoute } from '@tanstack/react-router'

import { BreadcrumbTrail, PageHeader, Skeleton } from '@/components/ui'
import { useDocumentTitle } from '@/hooks'
import { DocumentsList, useDocumentsWebsocket } from '@/modules/documents'
import { useFolder, useLoadingFolder } from '@/modules/folders'

export const Route = createFileRoute('/_authenticated/documents/folder/$slug/')(
  {
    staticData: { dynamicTitle: true },
    component: FolderView,
    shouldReload: false,
  },
)

export function FolderView() {
  useDocumentsWebsocket()
  const { slug } = Route.useParams()
  const folder = useFolder()
  const isLoading = useLoadingFolder()
  useDocumentTitle(folder?.name ?? 'Folder')

  const name = isLoading ? <Skeleton className="w-32" /> : folder?.name

  return (
    <div className="space-y-6">
      <BreadcrumbTrail
        crumbs={[{ label: 'Documents', to: '/documents' }]}
        page={name}
      />

      <PageHeader title={name} subtitle="Documents in this folder." />

      <DocumentsList folderSlug={slug} />
    </div>
  )
}
